import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDateIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "#8E68F7",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.32812 1.33594V3.33594",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6719 1.33594V3.33594",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.32812 6.0625H13.6615",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 5.66927V11.3359C14 13.3359 13 14.6693 10.6667 14.6693H5.33333C3 14.6693 2 13.3359 2 11.3359V5.66927C2 3.66927 3 2.33594 5.33333 2.33594H10.6667C13 2.33594 14 3.66927 14 5.66927Z",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.4625 9.13411H10.4685",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.4625 12.1341H10.4685",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00155 9.13411H8.00753",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00155 12.1341H8.00753",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5328 9.13411H5.53878",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5328 12.1341H5.53878",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDateIcon;
